import { Fragment } from 'react';

import { formatNumber, money } from '~/utils/format';

import { Disclaimer, FactElement, Headline } from './styles';

const RoundInfo = ({ round, stats }) => {
  const meets = round.meets.map(meet => meet.track_name).join('/');
  return (
    <Fragment>
      <Headline>
        {round.bet_type}
        -statistik {meets}
      </Headline>

      <FactElement
        items={[
          {
            label: 'Medianutdelning',
            value: money(stats.median_payout),
            mean: `${formatNumber(stats.median_payout_total)} kr`,
          },
          {
            label: 'Favoritsegrar',
            value: `${stats.favourite_wins}%`,
            mean: `${stats.favourite_wins_total}%`,
          },
          {
            label: round.bet_type === 'V75' ? 'Hemmasegrar' : 'Spetssegrar',
            value:
              round.bet_type === 'V75'
                ? `${stats.home_wins}%`
                : `${stats.front_wins}%`,
            mean:
              round.bet_type === 'V75'
                ? `${stats.home_wins_total}%`
                : `${stats.front_wins_total}%`,
          },
        ]}
      />
      <Disclaimer>
        Data från och med 2015. Siffror inom parentes anger medelvärden för{' '}
        {round.bet_type}.
      </Disclaimer>
    </Fragment>
  );
};

export default RoundInfo;
